import { Outlet } from "@tanstack/react-router";
import { UpdateBanner } from "../components/UpdateBanner";
import { PosDbProvider } from "../components/PosDbProvider";

/** POS is a single-screen till app — internal navigation is state-driven (see PosApp), not routed. */
export function RootLayout() {
  return (
    <PosDbProvider>
      <div className="cq-full-height pos-viewport" style={{ width: "100%", overflow: "hidden" }}>
        <UpdateBanner />
        <Outlet />
      </div>
    </PosDbProvider>
  );
}
